import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	{
		config: {
			flexLayout: 'column'
		},
		fields: [
			fieldsMap.get('label'),
			fieldsMap.get('backoffice_enabled')
		]
	}
];

const config: IFormConfig = {
	title: 'Nuovo metodo di incasso',
	editTitle: 'Modifica metodo di incasso',
	fields: formFields
};

export default config;
